import {
    useCallback,
} from 'react'

import {
    AssignPricingLaneGroupResponse,
} from '../../AQuotes.types'

import AQuoteLaneGroupOverview from './LaneGroupOverview'
import AssignPricingLanes from './AssignPricingLanes'

export default function AssignPricingLaneGroupUpdate({
    data,
    invalidate,
    refetch,
}: Readonly<{
    data: AssignPricingLaneGroupResponse,
    invalidate: () => void,
    refetch: () => void,
}>) {
    const onSuccess = useCallback(() => {
        invalidate()
        refetch()
    }, [
        refetch,
        invalidate,
    ])

    return (
        <>
            <AQuoteLaneGroupOverview data={data} />
            <AssignPricingLanes
                lanes={data?.lanes}
                onSuccess={onSuccess}
            />
        </>
    )
}
